import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RevenuePaymentMethodService {

  constructor(private http: HttpClient) { }

  getAll(filter: string  = "") {
    return this.http
    .get(`${environment.url}/payment_methods${filter}`).pipe(map((res: any) => res['hydra:member'])) as Observable<any[]>;
  }


}
